import { Link } from 'react-router-dom';
import { ANALYTICS_SOURCES } from 'shared/constants';
import navigationContextManager from 'shared/helpers/src/navigation-context-manager';
import { textWithFallback } from 'src/components/design-system/table';
import styles from './reports.module.scss';

/**
 * Cell renderer whose link stops row-click propagation so navigation and the
 * row's drill-down handler don't both fire.
 *
 * Reports live on a tab (`?tab=`) rather than their own route, so the route mapper
 * can't attribute them — the source is set here at click time instead. The event
 * links carry it in the URL (`?from=report`); for `/contacts/:id` it survives only
 * because the destination's mount effect runs before the tracker's `clearContext`,
 * and is lost when the contact isn't already in the store (deep link, cold load).
 * @param {import('ag-grid-community').ICellRendererParams & {
 *   getTo?: (data: object) => string | undefined,
 * }} params
 */
export function ReportLinkCell({ value, valueFormatted, data, getTo }) {
  const label = valueFormatted ?? textWithFallback({ value });
  const to = getTo?.(data);

  if (!to) return label;

  const setReportSource = () =>
    navigationContextManager.setContext({
      source: ANALYTICS_SOURCES.EDUCATIONAL_EVENTS_REPORT,
    });

  return (
    <Link
      className={styles.linkCell}
      to={to}
      onClick={e => {
        e.stopPropagation();
        setReportSource();
      }}
      onKeyDown={e => {
        e.stopPropagation();
      }}>
      {label}
    </Link>
  );
}
